import { DataService } from '../../../shared/dataservice.service';
import { Component, OnInit, Input } from '@angular/core';
import { SalesOrder, SubSalesOrder, SOStatus, SSOStatus, monthFilter, PmTechnicalIP,  UiFunctionalKPI } from '../../../shared/misc-classes';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { KPIChartService } from '../../../shared/kpi-charts-service';
import * as Highcharts from 'highcharts';

@Component({
  selector: 'app-purchase-material-receipt-kpi',
  templateUrl: './purchase-material-receipt-kpi.component.html',
  styleUrls: ['./purchase-material-receipt-kpi.component.css']
})
export class PurchaseMaterialReceiptKpiComponent implements OnInit {

  @Input() pmTechSSO: PmTechnicalIP;
  soObj: SalesOrder;
  _soObjListKpi10: Array<SalesOrder>;

  filteredSOCount: number = 0;
  filteredSSOCount: number = 0;
  isDataViewUpdated4: boolean = false;
  isLoading: boolean = false;
  PurchaseKpi: Array<UiFunctionalKPI> = [];


  isManfMonthFilterSelectedKpi10: boolean = false;
  manfMonthFilterKpi10: monthFilter;

  Highcharts = Highcharts;

  totalDataCT: any;
  totalDataKpiChartOptionsCT: Highcharts.Options;
  panelWiseDataCT: any;
  panelWiseKpiChartOptionsCT: Highcharts.Options;

  totalDataBR: any;
  totalDataKpiChartOptionsBR: Highcharts.Options;
  panelWiseDataBR: any;
  panelWiseKpiChartOptionsBR: Highcharts.Options;

  totalDataRELAY: any;
  totalDataKpiChartOptionsRELAY: Highcharts.Options;
  panelWiseDataRELAY: any;
  panelWiseKpiChartOptionsRELAY: Highcharts.Options;

  
  totalDataMB: any;
  totalDataKpiChartOptionsMB: Highcharts.Options;
  panelWiseDataMB: any;
  panelWiseKpiChartOptionsMB: Highcharts.Options;



  
  constructor(public _dataService: DataService, public dialog: MatDialog,
    private _kpiCharServ: KPIChartService) { }

  ngOnInit() {
    try {
      this.loadSettingsFromCookies();
    } catch (e) {
      console.log(e);
    }

    this.loadData();
  }
  saveSettingsToCookies() {
    this._dataService.setCookie('s-manfmonth-sel-kpi-11', this.isManfMonthFilterSelectedKpi10 ? "1" : "0");
    if (this.isManfMonthFilterSelectedKpi10) {
      this._dataService.setCookie('s-manfmonth-val-kpi-11', this.manfMonthFilterKpi10.getCookieStr());
    }
  }
  loadSettingsFromCookies() {


    let _tmpManfMonthSel: string = this._dataService.getCookie('s-manfmonth-sel-kpi-11');
    if (_tmpManfMonthSel) {
      this.isManfMonthFilterSelectedKpi10 = (_tmpManfMonthSel == "1");

      let _tmpManfMonthVal: string = this._dataService.getCookie('s-manfmonth-val-kpi-11');
      if (_tmpManfMonthVal) {
        this.manfMonthFilterKpi10= monthFilter.getObjFromCookieStr(_tmpManfMonthVal);
      }
    }


    let _currDate: Date = new Date();
    if (this.manfMonthFilterKpi10 == null) {
      this.manfMonthFilterKpi10 = new monthFilter(_currDate.getMonth() + 1, _currDate.getFullYear(),
        _currDate.getMonth() + 1, _currDate.getFullYear());
    }

  }
  loadData() {
    this.isLoading = true;
    this._dataService.getDataDefinitions().subscribe(res => {
      this._dataService.getAllSalesOrder(1).subscribe((_soObjAr: Array<SalesOrder>) => {
        this._soObjListKpi10 = _soObjAr.filter((_tmpSO2: SalesOrder) => {
          //test the filter.
          // if(_tmpSO2.projectStatus == SOStatus.Dispatched || _tmpSO2.projectStatus == SOStatus.Archived)
          if (_tmpSO2.projectStatus == SOStatus.Dispatched) {
            return false;
          }
          return true;
        });
        this.filterRows();
      });
    });
  }

  getClassName(_temp: number): string {
    if (_temp < 6) {
      return "bg-grey";
    } else if (_temp >= 6 && _temp < 10) {
      return "bg-yellow";
    } else if (_temp > 10) {
      return "bg-green";
    }
  }



  reloadData(): void {
    this.isLoading = true;
    this.loadData();
  }
  clearFilters(): void {

    this.isManfMonthFilterSelectedKpi10 = false;
    this.isLoading = true;
    this.loadData();

    setTimeout(() => {
      this.saveSettingsToCookies();
    }, 10);
  }



  filterRows(): void {
    this.isLoading = true;
    setTimeout(() => {
      this.filterRowsLogic2();
      this.isLoading = false;
    }, 5);
    this.saveSettingsToCookies();
  }


  private displaySOwithNoSSO() {
    if (this.isManfMonthFilterSelectedKpi10 == true

    ) {
      return false;
    }

    return true;
  }


  filterRowsLogic2() {
    let _tmpSOCounter: number = 0;
    let _tmpSSOCounter: number = 0;
    let _tmpPurchaseKpi: Array<UiFunctionalKPI> = [];

    let _totalQtyCT: number = 0;
    let _delayQtyCT: number = 0;
    let _onTimeQtyCT: number = 0;
    let _delayQtyCTZS1: number = 0;
    let _onTimeQtyCTZS1: number = 0;
    let _delayQtyCTZS1DBB: number = 0;
    let _onTimeQtyCTZS1DBB: number = 0;
    let _delayQtyCTZS2: number = 0;
    let _onTimeQtyCTZS2: number = 0;
    let _delayQtyCTZS9: number = 0;
    let _onTimeQtyCTZS9: number = 0;
    let _delayQtyCTZN1: number = 0;
    let _onTimeQtyCTZN1: number = 0;

    let _totalQtyBR: number = 0;
    let _delayQtyBR: number = 0;
    let _onTimeQtyBR: number = 0;
    let _delayQtyBRZS1: number = 0;
    let _onTimeQtyBRZS1: number = 0;
    let _delayQtyBRZS1DBB: number = 0;
    let _onTimeQtyBRZS1DBB: number = 0;
    let _delayQtyBRZS2: number = 0;
    let _onTimeQtyBRZS2: number = 0;
    let _delayQtyBRZS9: number = 0;
    let _onTimeQtyBRZS9: number = 0;
    let _delayQtyBRZN1: number = 0;
    let _onTimeQtyBRZN1: number = 0;

    let _totalQtyRELAY: number = 0;
    let _delayQtyRELAY: number = 0;
    let _onTimeQtyRELAY: number = 0;
    let _delayQtyRELAYZS1: number = 0;
    let _onTimeQtyRELAYZS1: number = 0;
    let _delayQtyRELAYZS1DBB: number = 0;
    let _onTimeQtyRELAYZS1DBB: number = 0;
    let _delayQtyRELAYZS2: number = 0;
    let _onTimeQtyRELAYZS2: number = 0;
    let _delayQtyRELAYZS9: number = 0;
    let _onTimeQtyRELAYZS9: number = 0;
    let _delayQtyRELAYZN1: number = 0;
    let _onTimeQtyRELAYZN1: number = 0;

    let _totalQtyMB: number = 0;
    let _delayQtyMB: number = 0;
    let _onTimeQtyMB: number = 0;
    let _delayQtyMBZS1: number = 0;
    let _onTimeQtyMBZS1: number = 0;
    let _delayQtyMBZS1DBB: number = 0;
    let _onTimeQtyMBZS1DBB: number = 0;
    let _delayQtyMBZS2: number = 0;
    let _onTimeQtyMBZS2: number = 0;
    let _delayQtyMBZS9: number = 0;
    let _onTimeQtyMBZS9: number = 0;
    let _delayQtyMBZN1: number = 0;
    let _onTimeQtyMBZN1: number = 0;

   

    let _equpList = ["001", "002", "037", "003", "004", "005", "006", "007", "008", "009", "010", "011", "012", "013", "014", "015", "016", "017", "018"];

    let _showSOWithNoSSO: boolean = this.displaySOwithNoSSO();

    for (var i = 0; i < this._soObjListKpi10.length; i++) {
      let _tmpSO: SalesOrder = this._soObjListKpi10[i];

      let _isSOPassedFilter: boolean = true;
      if (_isSOPassedFilter == true) {
        let _filteredSSO: Array<SubSalesOrder> = this.getFilteredSubOrders(_tmpSO.subSalesOrder);

        if (_filteredSSO.length > 0 || (_tmpSO.subSalesOrder.length == 0 && _showSOWithNoSSO == true)) {

          let _tmpSSOobj: UiFunctionalKPI;

          _tmpSOCounter++;

          _filteredSSO.forEach((_tmpSSO: SubSalesOrder) => {

            

            // Check for CT Last Receipt planned and Actual Dates      

            if (_tmpSSO.purchaseMatReceipt.ctPTActualReceiptDate != null) {
              let _ctActual = _tmpSSO.purchaseMatReceipt.ctPTActualReceiptDate.getTime();
              let _isRevised = null;
              let _isRequested;
              let _ctOtherDate;
              if(  _tmpSSO.purchaseMatReceipt.ctPTRequestedReceiptDate==null){
                _isRequested = false;
                _ctOtherDate = _tmpSSO.purchaseMatReceipt.ctPTPlannedReceiptDate.getTime();
                _isRevised = _tmpSSO.purchaseMatReceipt.ctPTPlannedReceiptDateIsRevised;
            }
            else{
              _isRequested = true;
             _ctOtherDate = _tmpSSO.purchaseMatReceipt.ctPTRequestedReceiptDate.getTime();
            }
            _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
              if (_equpList.includes(e.equipmentType)) {
                var temp: number = parseInt(e.panelQuantity, 10);
                if (temp > 0) {
                  _totalQtyCT += temp;
                  
                  
                }
              }
            });
              let _ctDiff_time =  _ctOtherDate - _ctActual;
              let _ctDiff = _ctDiff_time / (1000 * 3600 * 24);
              ///CT Last Receipt Finalization Delay
              if (_ctDiff < 0) {
              
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _delayQtyCT += temp;
                    }
                  }
                });

                let _individualDelayQtyCT = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyCTZS1 += temp;
                          _individualDelayQtyCT += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyCTZS1DBB += temp;
                          _individualDelayQtyCT += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyCTZS2 += temp;
                          _individualDelayQtyCT += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyCTZN1 += temp;
                          _individualDelayQtyCT += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyCTZS9 += temp;
                          _individualDelayQtyCT += temp;
                        }
                      }
                    });
                    break;
                }

                let _plannedTmp;
                let _revisedTmp;
                if(_isRevised!=null){
                  if(_isRevised == true){
                    _plannedTmp = null;
                    _revisedTmp = _tmpSSO.purchaseMatReceipt.ctPTPlannedReceiptDate;
                  }
                  else{
                    _plannedTmp = _tmpSSO.purchaseMatReceipt.ctPTPlannedReceiptDate;
                    _revisedTmp = null;
                  }
                }
                else{
                  _plannedTmp = null;
                  _revisedTmp = null;
                }
                let _requestedTmp = _isRequested==false?null:_tmpSSO.purchaseMatReceipt.ctPTRequestedReceiptDate;

                _tmpSSOobj = new UiFunctionalKPI(_tmpSSO.planningIP.plannedManufacturingMonth, 'CT Last Receipt',_tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualDelayQtyCT, _plannedTmp, _revisedTmp,
                _requestedTmp , _tmpSSO.purchaseMatReceipt.ctPTActualReceiptDate, _ctDiff, _tmpSSO.purchaseMatReceipt.ctPTActualReceiptToken.addNotes)
               
                  _tmpPurchaseKpi.push(_tmpSSOobj);
              }
              // CT Last Receipt Finalization on Time
              if (_ctDiff >= 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _onTimeQtyCT += temp;
                    }
                  }
                });

                let _individualOnTimeQtyCT = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyCTZS1 += temp;
                          _individualOnTimeQtyCT += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyCTZS1DBB += temp;
                          _individualOnTimeQtyCT += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyCTZS2 += temp;
                          _individualOnTimeQtyCT += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyCTZN1 += temp;
                          _individualOnTimeQtyCT += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyCTZS9 += temp;
                          _individualOnTimeQtyCT += temp;
                        }
                      }
                    });
                    break;
                }
                let _plannedTmp;
                let _revisedTmp;
                if(_isRevised!=null){
                  if(_isRevised == true){
                    _plannedTmp = null;
                    _revisedTmp = _tmpSSO.purchaseMatReceipt.ctPTPlannedReceiptDate;
                  }
                  else{
                    _plannedTmp = _tmpSSO.purchaseMatReceipt.ctPTPlannedReceiptDate;
                    _revisedTmp = null;
                  }
                }
                else{
                  _plannedTmp = null;
                  _revisedTmp = null;
                }
                let _requestedTmp = _isRequested==false?null:_tmpSSO.purchaseMatReceipt.ctPTRequestedReceiptDate;

                _tmpSSOobj = new UiFunctionalKPI(_tmpSSO.planningIP.plannedManufacturingMonth, 'CT Last Receipt',_tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualOnTimeQtyCT, _plannedTmp, _revisedTmp,
                _requestedTmp , _tmpSSO.purchaseMatReceipt.ctPTActualReceiptDate, _ctDiff, _tmpSSO.purchaseMatReceipt.ctPTActualReceiptToken.addNotes)

                _tmpPurchaseKpi.push(_tmpSSOobj);
              }  


            }

            // Check for BR requested date Planned and Actual Dates

            if (_tmpSSO.purchaseMatReceipt.breakerActualReceiptDate != null) {
              let _brActual = _tmpSSO.purchaseMatReceipt.breakerActualReceiptDate.getTime();
              let _isRevised = null;
              let _isRequested;
              let _brOtherDate;
              if(  _tmpSSO.purchaseMatReceipt.breakerRequestedReceiptDate==null){
                _isRequested = false;
                _brOtherDate = _tmpSSO.purchaseMatReceipt.breakerPlannedReceiptDate.getTime();
                _isRevised = _tmpSSO.purchaseMatReceipt.breakerPlannedReceiptDateIsRevised;
            }
            else{
              _isRequested = true;
              _brOtherDate = _tmpSSO.purchaseMatReceipt.breakerRequestedReceiptDate.getTime();
            }
            _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
              if (_equpList.includes(e.equipmentType)) {
                var temp: number = parseInt(e.panelQuantity, 10);
                if (temp > 0) {
                  _totalQtyBR += temp;
                  
                  
                }
              }
            });
              let _brDiff_time =  _brOtherDate - _brActual;
              let _brDiff = _brDiff_time / (1000 * 3600 * 24);
              ///BR requested date Finalization Delay
              if (_brDiff < 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _delayQtyBR += temp;
                    }
                  }
                });

                let _individualDelayQtyBR = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyBRZS1 += temp;
                          _individualDelayQtyBR += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyBRZS1DBB += temp;
                          _individualDelayQtyBR += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyBRZS2 += temp;
                          _individualDelayQtyBR += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyBRZN1 += temp;
                          _individualDelayQtyBR += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyBRZS9 += temp;
                          _individualDelayQtyBR += temp;
                        }
                      }
                    });
                    break;
                }

                let _plannedTmp;
                let _revisedTmp;
                if(_isRevised!=null){
                  if(_isRevised == true){
                    _plannedTmp = null;
                    _revisedTmp = _tmpSSO.purchaseMatReceipt.breakerPlannedReceiptDate;
                  }
                  else{
                    _plannedTmp = _tmpSSO.purchaseMatReceipt.breakerPlannedReceiptDate;
                    _revisedTmp = null;
                  }
                }
                else{
                  _plannedTmp = null;
                  _revisedTmp = null;
                }
                let _requestedTmp = _isRequested==false?null:_tmpSSO.purchaseMatReceipt.breakerRequestedReceiptDate;


                _tmpSSOobj = new UiFunctionalKPI(_tmpSSO.planningIP.plannedManufacturingMonth, 'Breaker',_tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualDelayQtyBR, _plannedTmp, _revisedTmp,
                  _requestedTmp, _tmpSSO.purchaseMatReceipt.breakerActualReceiptDate, _brDiff, _tmpSSO.purchaseMatReceipt.breakerActualReceiptToken.addNotes)
                
                  _tmpPurchaseKpi.push(_tmpSSOobj);
              }
              //BR  on Time
              if (_brDiff >= 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _onTimeQtyBR += temp;
                    }
                  }
                });

                let _individualOnTimeQtyBR = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyBRZS1 += temp;
                          _individualOnTimeQtyBR += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyBRZS1DBB += temp;
                          _individualOnTimeQtyBR += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyBRZS2 += temp;
                          _individualOnTimeQtyBR += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyBRZN1 += temp;
                          _individualOnTimeQtyBR += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyBRZS9 += temp;
                          _individualOnTimeQtyBR += temp;
                        }
                      }
                    });
                    break;
                }
                let _plannedTmp;
                let _revisedTmp;
                if(_isRevised!=null){
                  if(_isRevised == true){
                    _plannedTmp = null;
                    _revisedTmp = _tmpSSO.purchaseMatReceipt.breakerPlannedReceiptDate;
                  }
                  else{
                    _plannedTmp = _tmpSSO.purchaseMatReceipt.breakerPlannedReceiptDate;
                    _revisedTmp = null;
                  }
                }
                else{
                  _plannedTmp = null;
                  _revisedTmp = null;
                }
                let _requestedTmp = _isRequested==false?null:_tmpSSO.purchaseMatReceipt.breakerRequestedReceiptDate;


                _tmpSSOobj = new UiFunctionalKPI(_tmpSSO.planningIP.plannedManufacturingMonth, 'Breaker',_tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualOnTimeQtyBR, _plannedTmp, _revisedTmp,
                  _requestedTmp, _tmpSSO.purchaseMatReceipt.breakerActualReceiptDate, _brDiff, _tmpSSO.purchaseMatReceipt.breakerActualReceiptToken.addNotes)
              
                  _tmpPurchaseKpi.push(_tmpSSOobj);
              }     


            }

            // Check for Relay Planned and Actual Dates

            if (_tmpSSO.purchaseMatReceipt.relayActualReceiptDate != null) {
              let _relayActual = _tmpSSO.purchaseMatReceipt.relayActualReceiptDate.getTime();
              let _isRevised = null;
              let _isRequested;
              let _relayOtherDate;
              if(  _tmpSSO.purchaseMatReceipt.relayRequestedReceiptDate==null){
                _isRequested = false;
                _relayOtherDate = _tmpSSO.purchaseMatReceipt.relayPlannedReceiptDate.getTime();
                _isRevised = _tmpSSO.purchaseMatReceipt.relayPlannedReceiptDateIsRevised;
            }
            else{
              _isRequested = true;
              _relayOtherDate = _tmpSSO.purchaseMatReceipt.relayRequestedReceiptDate.getTime();
            }
            _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
              if (_equpList.includes(e.equipmentType)) {
                var temp: number = parseInt(e.panelQuantity, 10);
                if (temp > 0) {
                  _totalQtyRELAY += temp;
                  
                  
                }
              }
            });
              let _relayDiff_time =  _relayOtherDate - _relayActual;
              let _relayDiff = _relayDiff_time / (1000 * 3600 * 24);
              ///RELAY requested date Finalization Delay
              if (_relayDiff < 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _delayQtyRELAY += temp;
                    }
                  }
                });

                let _individualDelayQtyRelay = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyRELAYZS1 += temp;
                          _individualDelayQtyRelay += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyRELAYZS1DBB += temp;
                          _individualDelayQtyRelay += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyRELAYZS2 += temp;
                          _individualDelayQtyRelay += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyRELAYZN1 += temp;
                          _individualDelayQtyRelay += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyRELAYZS9 += temp;
                          _individualDelayQtyRelay += temp;
                        }
                      }
                    });
                    break;
                }
                
                let _plannedTmp;
                let _revisedTmp;
                if(_isRevised!=null){
                  if(_isRevised == true){
                    _plannedTmp = null;
                    _revisedTmp = _tmpSSO.purchaseMatReceipt.relayPlannedReceiptDate;
                  }
                  else{
                    _plannedTmp = _tmpSSO.purchaseMatReceipt.relayPlannedReceiptDate;
                    _revisedTmp = null;
                  }
                }
                else{
                  _plannedTmp = null;
                  _revisedTmp = null;
                }
                let _requestedTmp = _isRequested==false?null:_tmpSSO.purchaseMatReceipt.relayRequestedReceiptDate;

                _tmpSSOobj = new UiFunctionalKPI(_tmpSSO.planningIP.plannedManufacturingMonth, 'Relay', _tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualDelayQtyRelay, _plannedTmp, _revisedTmp,
                  _requestedTmp, _tmpSSO.purchaseMatReceipt.relayActualReceiptDate, _relayDiff,  _tmpSSO.purchaseMatReceipt.relayActualReceiptToken.addNotes)
                
                  _tmpPurchaseKpi.push(_tmpSSOobj);
              }
              //RELAY requested date on Time
              if (_relayDiff >= 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _onTimeQtyRELAY += temp;
                    }
                  }
                });

                let _individualOnTimeQtyRelay = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyRELAYZS1 += temp;
                          _individualOnTimeQtyRelay += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyRELAYZS1DBB += temp;
                          _individualOnTimeQtyRelay += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyRELAYZS2 += temp;
                          _individualOnTimeQtyRelay += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyRELAYZN1 += temp;
                          _individualOnTimeQtyRelay += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyRELAYZS9 += temp;
                          _individualOnTimeQtyRelay += temp;
                        }
                      }
                    });
                    break;
                }

                let _plannedTmp;
                let _revisedTmp;
                if(_isRevised!=null){
                  if(_isRevised == true){
                    _plannedTmp = null;
                    _revisedTmp = _tmpSSO.purchaseMatReceipt.relayPlannedReceiptDate;
                  }
                  else{
                    _plannedTmp = _tmpSSO.purchaseMatReceipt.relayPlannedReceiptDate;
                    _revisedTmp = null;
                  }
                }
                else{
                  _plannedTmp = null;
                  _revisedTmp = null;
                }

                let _requestedTmp = _isRequested==false?null:_tmpSSO.purchaseMatReceipt.relayRequestedReceiptDate;

                _tmpSSOobj = new UiFunctionalKPI(_tmpSSO.planningIP.plannedManufacturingMonth, 'Relay', _tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualOnTimeQtyRelay, _plannedTmp, _revisedTmp,
                  _requestedTmp, _tmpSSO.purchaseMatReceipt.relayActualReceiptDate, _relayDiff,  _tmpSSO.purchaseMatReceipt.relayActualReceiptToken.addNotes)
                
                _tmpPurchaseKpi.push(_tmpSSOobj);
              }     


            }

            // Check for MB Planned and Actual Dates

            if (_tmpSSO.purchaseMatReceipt.meteringBoxActualReceiptDate != null) {
              let _mbActual = _tmpSSO.purchaseMatReceipt.meteringBoxActualReceiptDate.getTime();
              let _isRevised = null;
              let _isRequested;
              let _mbOtherDate;
              if( _tmpSSO.purchaseMatReceipt.meteringBoxRequestedReceiptDate==null){
                _isRequested = false;
                _mbOtherDate = _tmpSSO.purchaseMatReceipt.meteringBoxPlannedReceiptDate.getTime();
                _isRevised = _tmpSSO.purchaseMatReceipt.meteringBoxPlannedReceiptDateIsRevised;
            }
            else{
              _isRequested = true;
              _mbOtherDate = _tmpSSO.purchaseMatReceipt.meteringBoxRequestedReceiptDate.getTime();
            }
            _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
              if (_equpList.includes(e.equipmentType)) {
                var temp: number = parseInt(e.panelQuantity, 10);
                if (temp > 0) {
                  _totalQtyMB += temp;
                  
                  
                }
              }
            });
              let _mbDiff_time =  _mbOtherDate - _mbActual;
              let _mbDiff = _mbDiff_time / (1000 * 3600 * 24);
              ///MB requested date Finalization Delay
              if (_mbDiff < 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _delayQtyMB += temp;
                    }
                  }
                });

                let _individualDelayQtyMB = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyMBZS1 += temp;
                          _individualDelayQtyMB += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyMBZS1DBB += temp;
                          _individualDelayQtyMB += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyMBZS2 += temp;
                          _individualDelayQtyMB += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyMBZN1 += temp;
                          _individualDelayQtyMB += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _delayQtyMBZS9 += temp;
                          _individualDelayQtyMB += temp;
                        }
                      }
                    });
                    break;
                }
                let _plannedTmp;
                let _revisedTmp;
                if(_isRevised!=null){
                  if(_isRevised == true){
                    _plannedTmp = null;
                    _revisedTmp = _tmpSSO.purchaseMatReceipt.meteringBoxPlannedReceiptDate;
                  }
                  else{
                    _plannedTmp = _tmpSSO.purchaseMatReceipt.meteringBoxPlannedReceiptDate;
                    _revisedTmp = null;
                  }
                }
                else{
                  _plannedTmp = null;
                  _revisedTmp = null;
                }
                let _requestedTmp =  _isRequested==false?null:_tmpSSO.purchaseMatReceipt.meteringBoxRequestedReceiptDate;

                _tmpSSOobj = new UiFunctionalKPI(_tmpSSO.planningIP.plannedManufacturingMonth, 'MB',_tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualDelayQtyMB, _plannedTmp, _revisedTmp,
                _requestedTmp , _tmpSSO.purchaseMatReceipt.meteringBoxActualReceiptDate, _mbDiff, _tmpSSO.purchaseMatReceipt.meteringBoxActualReceiptToken.addNotes )

                _tmpPurchaseKpi.push(_tmpSSOobj);
              }
              //MB requested date on Time
              if (_mbDiff >= 0) {
                _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                  if (_equpList.includes(e.equipmentType)) {
                    var temp: number = parseInt(e.panelQuantity, 10);
                    if (temp > 0) {
                      _onTimeQtyMB += temp;
                    }
                  }
                });

                let _individualOnTimeQtyMB = 0;
                switch (_tmpSSO.pmTechSubSalesOrder.productVarient) {
                  case "001":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyMBZS1 += temp;
                          _individualOnTimeQtyMB += temp;
                        }
                      }
                    });
                    break;
                  case "002":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyMBZS1DBB += temp;
                          _individualOnTimeQtyMB += temp;
                        }
                      }
                    });

                    break;
                  case "003":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyMBZS2 += temp;
                          _individualOnTimeQtyMB += temp;
                        }
                      }
                    });

                    break;
                  case "004":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyMBZN1 += temp;
                          _individualOnTimeQtyMB += temp;
                        }
                      }
                    });

                    break;
                  case "005":
                    _tmpSSO.pmTechSubSalesOrder.equipmentList.forEach((e) => {
                      if (_equpList.includes(e.equipmentType)) {
                        var temp: number = parseInt(e.panelQuantity, 10);
                        if (temp > 0) {
                          _onTimeQtyMBZS9 += temp;
                          _individualOnTimeQtyMB += temp;
                        }
                      }
                    });
                    break;
                }
                let _plannedTmp;
                let _revisedTmp;
                if(_isRevised!=null){
                  if(_isRevised == true){
                    _plannedTmp = null;
                    _revisedTmp = _tmpSSO.purchaseMatReceipt.meteringBoxPlannedReceiptDate;
                  }
                  else{
                    _plannedTmp = _tmpSSO.purchaseMatReceipt.meteringBoxPlannedReceiptDate;
                    _revisedTmp = null;
                  }
                }
                else{
                  _plannedTmp = null;
                  _revisedTmp = null;
                }
                let _requestedTmp =  _isRequested==false?null:_tmpSSO.purchaseMatReceipt.meteringBoxRequestedReceiptDate;

                _tmpSSOobj = new UiFunctionalKPI(_tmpSSO.planningIP.plannedManufacturingMonth, 'MB',_tmpSO.marketingIP.customerName , _tmpSO.marketingIP.salesOrderNo, _tmpSSO.subOrderNoId,
                _tmpSO.pmCommercial.isSaleOrderChangeApplicable, _tmpSO.pmCommercial.salesOrderNoNew, this._dataService.getProductVariantName(_tmpSSO.pmTechSubSalesOrder.productVarient), _individualOnTimeQtyMB, _plannedTmp, _revisedTmp,
                _requestedTmp , _tmpSSO.purchaseMatReceipt.meteringBoxActualReceiptDate, _mbDiff, _tmpSSO.purchaseMatReceipt.meteringBoxActualReceiptToken.addNotes )

                _tmpPurchaseKpi.push(_tmpSSOobj);
              }     


            }

          });

        }


      }

    }

    if (_totalQtyCT != 0 || _onTimeQtyCT != 0 || _delayQtyCT != 0) {
      this.totalDataCT = [{
        "data": [{
          name: 'Total Panel Quantity',
          color: '#6e6e6e',
          y: _totalQtyCT,
        },
        {
          name: 'On Time Panel',
          color: '#6e6e6e',
          y: _onTimeQtyCT,
        },
        {
          name: 'Delayed Panel',
          color: '#6e6e6e',
          y: _delayQtyCT,
        }]
      }

      ];
    }
    else { this.totalDataCT = null; }

    this.totalDataKpiChartOptionsCT = this._kpiCharServ.getTotalDataChartOptions(this.totalDataCT);

    if (_onTimeQtyCTZN1 != 0 || _onTimeQtyCTZS9 != 0 || _onTimeQtyCTZS1 != 0 || _onTimeQtyCTZS1DBB != 0 || _onTimeQtyCTZS2 != 0
      || _delayQtyCTZN1 != 0 || _delayQtyCTZS9 != 0 || _delayQtyCTZS1 != 0 || _delayQtyCTZS1DBB != 0 || _delayQtyCTZS2 != 0) {

      this.panelWiseDataCT = [{
        name: 'On Time',
        color: '#6e6e6e',
        type: 'column',
        data: [_onTimeQtyCTZN1, _onTimeQtyCTZS9, _onTimeQtyCTZS1, _onTimeQtyCTZS1DBB, _onTimeQtyCTZS2],
      },
      {
        name: 'Delay',
        color: '#ff000f',
        type: 'column',
        data: [_delayQtyCTZN1, _delayQtyCTZS9, _delayQtyCTZS1, _delayQtyCTZS1DBB, _delayQtyCTZS2],
      }

      ];
    }
    else { this.panelWiseDataCT = null; }

    this.panelWiseKpiChartOptionsCT = this._kpiCharServ.getPanelWiseChartOptions(this.panelWiseDataCT);


    ////

    if (_totalQtyBR != 0 || _onTimeQtyBR != 0 || _delayQtyBR != 0) {
      this.totalDataBR = [{
        "data": [{
          name: 'Total Panel Quantity',
          color: '#6e6e6e',
          y: _totalQtyBR,
        },
        {
          name: 'On Time Panel',
          color: '#6e6e6e',
          y: _onTimeQtyBR,
        },
        {
          name: 'Delayed Panel',
          color: '#6e6e6e',
          y: _delayQtyBR,
        }]
      }

      ];
    }
    else { this.totalDataBR = null; }

    this.totalDataKpiChartOptionsBR = this._kpiCharServ.getTotalDataChartOptions(this.totalDataBR);

    if (_onTimeQtyBRZN1 != 0 || _onTimeQtyBRZS9 != 0 || _onTimeQtyBRZS1 != 0 || _onTimeQtyBRZS1DBB != 0 || _onTimeQtyBRZS2 != 0
      || _delayQtyBRZN1 != 0 || _delayQtyBRZS9 != 0 || _delayQtyBRZS1 != 0 || _delayQtyBRZS1DBB != 0 || _delayQtyBRZS2 != 0) {

      this.panelWiseDataBR = [{
        name: 'On Time',
        color: '#6e6e6e',
        type: 'column',
        data: [_onTimeQtyBRZN1, _onTimeQtyBRZS9, _onTimeQtyBRZS1, _onTimeQtyBRZS1DBB, _onTimeQtyBRZS2],
      },
      {
        name: 'Delay',
        color: '#ff000f',
        type: 'column',
        data: [_delayQtyBRZN1, _delayQtyBRZS9, _delayQtyBRZS1, _delayQtyBRZS1DBB, _delayQtyBRZS2],
      }

      ];
    }
    else { this.panelWiseDataBR = null; }

    this.panelWiseKpiChartOptionsBR = this._kpiCharServ.getPanelWiseChartOptions(this.panelWiseDataBR);

    ////

    if (_totalQtyRELAY != 0 || _onTimeQtyRELAY != 0 || _delayQtyRELAY != 0) {
      this.totalDataRELAY = [{
        "data": [{
          name: 'Total Panel Quantity',
          color: '#6e6e6e',
          y: _totalQtyRELAY,
        },
        {
          name: 'On Time Panel',
          color: '#6e6e6e',
          y: _onTimeQtyRELAY,
        },
        {
          name: 'Delayed Panel',
          color: '#6e6e6e',
          y: _delayQtyRELAY,
        }]
      }

      ];
    }
    else { this.totalDataRELAY = null; }

    this.totalDataKpiChartOptionsRELAY = this._kpiCharServ.getTotalDataChartOptions(this.totalDataRELAY);

    if (_onTimeQtyRELAYZN1 != 0 || _onTimeQtyRELAYZS9 != 0 || _onTimeQtyRELAYZS1 != 0 || _onTimeQtyRELAYZS1DBB != 0 || _onTimeQtyRELAYZS2 != 0
      || _delayQtyRELAYZN1 != 0 || _delayQtyRELAYZS9 != 0 || _delayQtyRELAYZS1 != 0 || _delayQtyRELAYZS1DBB != 0 || _delayQtyRELAYZS2 != 0) {

      this.panelWiseDataRELAY = [{
        name: 'On Time',
        color: '#6e6e6e',
        type: 'column',
        data: [_onTimeQtyRELAYZN1, _onTimeQtyRELAYZS9, _onTimeQtyRELAYZS1, _onTimeQtyRELAYZS1DBB, _onTimeQtyRELAYZS2],
      },
      {
        name: 'Delay',
        color: '#ff000f',
        type: 'column',
        data: [_delayQtyRELAYZN1, _delayQtyRELAYZS9, _delayQtyRELAYZS1, _delayQtyRELAYZS1DBB, _delayQtyRELAYZS2],
      }

      ];
    }
    else { this.panelWiseDataRELAY = null; }

    this.panelWiseKpiChartOptionsRELAY = this._kpiCharServ.getPanelWiseChartOptions(this.panelWiseDataRELAY);

    ////

    if (_totalQtyMB != 0 || _onTimeQtyMB != 0 || _delayQtyMB != 0) {
      this.totalDataMB = [{
        "data": [{
          name: 'Total Panel Quantity',
          color: '#6e6e6e',
          y: _totalQtyMB,
        },
        {
          name: 'On Time Panel',
          color: '#6e6e6e',
          y: _onTimeQtyMB,
        },
        {
          name: 'Delayed Panel',
          color: '#6e6e6e',
          y: _delayQtyMB,
        }]
      }

      ];
    }
    else { this.totalDataMB = null; }

    this.totalDataKpiChartOptionsMB = this._kpiCharServ.getTotalDataChartOptions(this.totalDataMB);

    if (_onTimeQtyMBZN1 != 0 || _onTimeQtyMBZS9 != 0 || _onTimeQtyMBZS1 != 0 || _onTimeQtyMBZS1DBB != 0 || _onTimeQtyMBZS2 != 0
      || _delayQtyMBZN1 != 0 || _delayQtyMBZS9 != 0 || _delayQtyMBZS1 != 0 || _delayQtyMBZS1DBB != 0 || _delayQtyMBZS2 != 0) {

      this.panelWiseDataMB = [{
        name: 'On Time',
        color: '#6e6e6e',
        type: 'column',
        data: [_onTimeQtyMBZN1, _onTimeQtyMBZS9, _onTimeQtyMBZS1, _onTimeQtyMBZS1DBB, _onTimeQtyMBZS2],
      },
      {
        name: 'Delay',
        color: '#ff000f',
        type: 'column',
        data: [_delayQtyMBZN1, _delayQtyMBZS9, _delayQtyMBZS1, _delayQtyMBZS1DBB, _delayQtyMBZS2],
      }

      ];
    }
    else { this.panelWiseDataMB = null; }

    this.panelWiseKpiChartOptionsMB = this._kpiCharServ.getPanelWiseChartOptions(this.panelWiseDataMB);




    

    this.filteredSOCount = _tmpSOCounter;
    this.filteredSSOCount = _tmpSSOCounter;
    this.PurchaseKpi = _tmpPurchaseKpi;


    this.isDataViewUpdated4 = true;
    setTimeout(() => {
      this.isDataViewUpdated4 = false;
    }, 1000);
  }


  getManfMonthLabel(): string {
    if (this.isManfMonthFilterSelectedKpi10 == true) {
      return "Manufacturing Month : ";
    }
    else {
      return "Enable Manufacturing Month Filter";
    }
  }

  getManfFromMonthName(): string {
    if (this.manfMonthFilterKpi10) {
      return this.manfMonthFilterKpi10.fromMonthName;
    }
    return '';
  }
  getManfToMonthName(): string {
    if (this.manfMonthFilterKpi10) {
      return this.manfMonthFilterKpi10.toMonthName;
    }
    return '';
  }

  manfPrevFromMonth() {
    this.manfMonthFilterKpi10.prevFromMonth();
    this.filterRows();
  }
  manfNextFromMonth() {
    this.manfMonthFilterKpi10.nextFromMonth();
    this.filterRows();
  }
  manfPrevToMonth() {
    this.manfMonthFilterKpi10.prevToMonth();
    this.filterRows();
  }
  manfNextToMonth() {
    this.manfMonthFilterKpi10.nextToMonth();
    this.filterRows();
  }

  private getFilteredSubOrders(_ssoAr: Array<SubSalesOrder>): Array<SubSalesOrder> {
    return _ssoAr.filter((_sso: SubSalesOrder) => {
      //check for failure cases
      //dont show if sub order is dispatched
      if (_sso.isSSOStatusSet(SSOStatus.Dispatched) == true) return false;

      //check if mfg month 
      if (this.isManfMonthFilterPassed(_sso.manufacturingMonth) == false) return false;
      return true;
    });
  }


  private isManfMonthFilterPassed(_manfMonth: Date) {
    if (this.isManfMonthFilterSelectedKpi10 == true && this.manfMonthFilterKpi10 != null) {
      if (this.manfMonthFilterKpi10.isWithInFilterScope(_manfMonth) == false) {
        return false;
      }
    }
    return true;
  }

}
